
import React from 'react';
import {useIntl} from 'react-intl';

function getMessage(intl,status) {
  const msg = {
    "supported": intl.formatMessage({id: "domain.supported"}),
    "child": intl.formatMessage({id: "domain.child"}),
    "unsupported":intl.formatMessage({id: "domain.unsupported"}),
    "null_mx": intl.formatMessage({id: "domain.null_mx"}),
    "error": intl.formatMessage({id: "domain.error"}),
    "bad": intl.formatMessage({id: "domain.bad"}),
    "not_found": intl.formatMessage({id: "domain.not_found"}),
    "tcp_not_supported": intl.formatMessage({id: "ns.tcp_not_supported"}),
    "no_data": "no_data"
  }
  if(msg[status] == null) {
    return "no_data"
  }
  return msg[status]
}
function getClassName(status) {
  const className = {
    "supported": "table-success",
    "child": "",
    "unsupported":"table-danger",
    "null_mx": "",
    "error": "table-warning",
    "bad": "table-warning",
    "not_found": "table-warning",
    "tcp_not_supported": "table-warning",
    "no_data": ""
  }
  if(className[status] == null) {
    return ""
  }
  return className[status]
}

export function Status(props) {
  const intl = useIntl()
  const msg = getMessage(intl, props.data.status)
  const className = getClassName(props.data.status)
  return (
    <td className={className}>
      {msg}
    </td>
  )
}

function Server(data) {
  if (data.addresses) {
    
    var addresses = data.addresses.map(function(addr,i){
      return (
        <li key={i}>{addr}</li>
      )
    })
    addresses = (
      <ul>
        {addresses}
      </ul>
    )
  }
  return (
    <div>
      {data.name}
      {addresses}
    </div>
  )
}

export function MxStatus(props) {
  const intl = useIntl()
  var exchanges = ''
  if(props.data.exchanges) {
    var mxs = props.data.exchanges
    exchanges = Object.keys(props.data.exchanges).map(function(name,i){
      return (
        <Server key={i} name={name} addresses={mxs[name]} />
      )
    })
  }
  const msg = getMessage(intl, props.data.status)
  const className = getClassName(props.data.status)
  return (
    <td className={className}>
      {msg}
      {exchanges}
    </td>
  )
}

export function NsStatus(props) {
  const intl = useIntl()
  var nameservers = ''
  if(props.data.nameservers) {
    var ns = props.data.nameservers
    nameservers = Object.keys(props.data.nameservers).map(function(name,i){
      return (
        <Server key={i} name={name} addresses={ns[name]} />
      )
    })
  }
  const msg = getMessage(intl, props.data.status)
  const className = getClassName(props.data.status)
  return (
    <td className={className}>
      {msg}
      {nameservers}
    </td>
  )
}
